/**
 * Enum for the different states in HTMLMediaElement#readyState.
 * @enum {number}
 */
export enum VideoReadyState {
  /** No information is available about the resource. */
  HaveNothing = 0,
  /** Metadata is retrieved. User can seek. */
  HaveMetadata = 1,
  /** Data is available to play the current frame. */
  HaveCurrentData = 2,
  /** Data is available to play at least two frames. */
  HaveFutureData = 3,
  /** Data is available to play until end of media with current download rate. */
  HaveEnoughData = 4,
}
